import { aboutIntro } from '~/content/about';

export function AboutIntro() {
  return (
    <section className="px-5 py-16 md:py-[100px] md:pt-[100px] lg:px-20 lg:pt-[120px] lg:pb-[100px]">
      <div className="mx-auto w-full max-w-[1280px]">
        {aboutIntro.paragraphs.map((text) => (
          <p
            key={text.slice(0, 40)}
            className="mx-auto mb-6 max-w-[820px] text-center text-[28px] leading-[1.3] font-semibold tracking-[-0.02em] text-ink min-[480px]:mb-10 sm:max-w-[750px] sm:text-[40px] lg:max-w-[820px] lg:text-[48px]">
            {text}
          </p>
        ))}
        <div className="mt-[39px] flex flex-wrap items-center justify-center gap-6 min-[480px]:mt-16 min-[480px]:gap-8 lg:gap-[50px]">
          {aboutIntro.logos.map((logo) => (
            <img
              key={logo.src}
              src={logo.src}
              alt={logo.alt}
              width={logo.width}
              height={logo.height}
              className="h-[18px] w-auto"
              loading="lazy"
            />
          ))}
        </div>
      </div>
    </section>
  );
}
